import type { FormSearchType, SearchOperatorItem } from './types';

export type { SearchOperatorItem } from './types';

export type SearchFormInOperator = 'in' | 'notIn';
export type SearchFormStringLikeOperator = 'contains' | 'doesNotContain' | '=' | '!=' | 'startsWith' | 'endsWith';
export type SearchFormDateOperator = '=' | '<' | '>' | '<=' | '>=';
export type SearchFormNumberOperator = '=' | '!=' | '>' | '<' | '>=' | '<=';

export const searchFormInOperators: SearchOperatorItem[] = [
  { label: 'in', value: 'in' },
  { label: 'not in', value: 'notIn' },
];

export const searchStringLikeOperators: SearchOperatorItem[] = [
  { label: 'contains', value: 'contains' },
  { label: 'does not contain', value: 'doesNotContain' },
  { label: 'is', value: '=' },
  { label: 'is not', value: '!=' },
  { label: 'starts with', value: 'startsWith' },
  { label: 'ends with', value: 'endsWith' },
];

export const searchDateOperators: SearchOperatorItem[] = [
  { label: 'is', value: '=' },
  { label: 'before', value: '<' },
  { label: 'after', value: '>' },
  { label: 'before or equal', value: '<=' },
  { label: 'after or equal', value: '>=' },
];

export const searchNumberOperators: SearchOperatorItem[] = [
  { label: 'is', value: '=' },
  { label: 'is not', value: '!=' },
  { label: 'greater than', value: '>' },
  { label: 'less than', value: '<' },
  { label: 'greater than or equal', value: '>=' },
  { label: 'less than or equal', value: '<=' },
];

export const searchFormInOperatorValues: SearchFormInOperator[] = ['in', 'notIn'];

export const searchFormStringLikeOperatorValues: SearchFormStringLikeOperator[] = [
  'contains',
  'doesNotContain',
  '=',
  '!=',
  'startsWith',
  'endsWith',
];

export const searchFormDateOperatorValues: SearchFormDateOperator[] = ['=', '<', '>', '<=', '>='];

export const searchFormNumberOperatorValues: SearchFormNumberOperator[] = ['=', '!=', '>', '<', '>=', '<='];

export const defaultOperatorsByType: Record<FormSearchType, SearchOperatorItem[]> = {
  input: searchStringLikeOperators,
  select: searchStringLikeOperators,
  'select-many': searchFormInOperators,
  'select-menu': searchFormInOperators,
  'select-menu-many': searchFormInOperators,
  calendar: searchDateOperators,
  number: searchNumberOperators,
  tags: searchFormInOperators,
  generic: searchFormInOperators,
};
